import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Smooth Progress Bar
// Category: progress-indicators · Tags: data, progress, bar, loading, animated
export default function DataProgressBarSmooth1000Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const target = 0.78;
  const progress = spring({ frame, fps, config: { damping: 18, mass: 1 } }) * target;
  const pct = Math.round(progress * 100);
  return (
    <AbsoluteFill style={{ background: "#0a0e1a", justifyContent: "center", alignItems: "center", padding: 80 }}>
      <div style={{ width: "100%", maxWidth: 600 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20, fontFamily: "Inter, sans-serif" }}>
          <span style={{ color: "#f8fafc", fontSize: 32, fontWeight: 600 }}>Carregando</span>
          <span style={{ color: "#06b6d4", fontSize: 32, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{pct}%</span>
        </div>
        <div style={{ width: "100%", height: 24, background: "#1e293b", borderRadius: 12, overflow: "hidden" }}>
          <div style={{
            width: `${progress * 100}%`, height: "100%",
            background: "linear-gradient(90deg, #06b6d4, #a855f7)",
            borderRadius: 12,
            boxShadow: "0 0 24px rgba(6,182,212,0.6)",
          }} />
        </div>
        <div style={{ marginTop: 16, color: "#94a3b8", fontSize: 22, fontFamily: "Inter" }}>
          {interpolate(progress, [0, target], [0, 100]) < 100 ? "Processando dados..." : "Concluído"}
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
